// Define a service using a base URL and expected endpoints
// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiConfig } from '../../config'
import { getHeaders, ApiScope } from '../silentAuth'


export const energyMetersApi = createApi({
    reducerPath: 'energyMetersApi',
    baseQuery: fetchBaseQuery({
        baseUrl: apiConfig.energyMetersApiUrl,
        prepareHeaders: async (headers, { getState }) => { return await getHeaders(ApiScope, headers); }
    }),
    tagTypes: ['EnergyMeters'],
    endpoints: (builder) => ({
        getEnergyMeters: builder.query<any, string>({
            query: (args) =>  args && args !== '' ? `v2/energymeters?${args}` : `v2/energymeters`,
        }),
        getEnergyMetersFromBuilding: builder.query<any, { resourceGroupId: string, buildingId: string, queryparameters: string}>({
            query: (args) =>  args.queryparameters  ? `v2/energymeters/${args.resourceGroupId}/${args.buildingId}?${args.queryparameters}` : `v2/energymeters/${args.resourceGroupId}/${args.buildingId}`,
        })
    })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetEnergyMetersQuery,
    useGetEnergyMetersFromBuildingQuery
} = energyMetersApi


